module.exports = __webpack_public_path__ + "img/20ne.6b646e0d.svg";